module.exports = __webpack_public_path__ + "img/util-tab-1.100e2446.svg";